import VueApollo from 'vue-apollo'
import Vue from 'vue'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import { HttpLink } from 'apollo-link-http'
import { ApolloLink, split, concat } from 'apollo-link'
import config from '../assets/js/config'
import store from '../store'

const authMiddleware = new ApolloLink((operation, forward) => {
  let token = store.state.user && store.state.user.hasuraToken
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : 'null'
    }
  })
  return forward(operation)
})

let httpUri = `https://${config.hasuraUrl}/graphql`
let wsUri = `wss://${config.hasuraUrl}/graphql`
const httpLink = new HttpLink({
  uri: httpUri
})

const wsLink = new WebSocketLink({
  uri: wsUri,
  options: {
    lazy: true,
    reconnect: true,
    timeout: 30000,
    connectionParams: async () => {
      let token = store.state.user && store.state.user.hasuraToken
      return { headers: {
        authorization: token ? `Bearer ${token}` : 'test'
      }
      }
    }
  }
})

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
  },
  wsLink,
  httpLink
)

const apolloClient = new ApolloClient({
  link: concat(authMiddleware, link),
  cache: new InMemoryCache(),
  connectToDevTools: true,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore'
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    }
  }
})

Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})
export default apolloProvider
